import React from 'react';
import { WeaLocaleProvider } from 'ecCom';
import { addContentPath } from '../../util/pathUtil';
const getLabel = WeaLocaleProvider.getLabel;
import Header from './Common/header';

export default class Content_blogStatus extends React.Component {
    render() {
        const { data = {}, eid } = this.props;
        const { moreLocal, iconMore } = data;
        const tr = (
            <tr height="18">
                <td width="8"><img src={addContentPath('/images/homepage/style/style1/esymbol_wev8.gif')} alt="" /></td>
                <td width="*"><a href="javascript:;"><font className="font">{getLabel(387821, 'Gmail Labs推出搜索自动完成功能')}</font></a></td>
            </tr>
        );
        const tr2 = (
            <tr className="sparator" height="1px">
                <td colSpan="3" />
            </tr>
        );

        return (
            <div className="item" id={`item_${eid}`}>
                <Header ecId={`${this && this.props && this.props.ecId || ''}_Header@zpaxpj`} data={data} eid={eid} />
                <div className="content" id={`content_${eid}`}>
                    <div className="content_view" id={`content_view_id_${eid}`}>
                        <div className="tab2">
                            <table height="32" cellSpacing="0" cellPadding="0">
                                <tr>
                                    <td className="tab2selected" style={{ width: '84px' }}>{`${getLabel(17744, '更新')} (3678)`}</td>
                                    <td className="tab2unselected" style={{ width: '84px' }}>{`${getLabel(675, '评论')}(0)`}</td>
                                    <td className="tab2unselected" style={{ width: '84px' }}>{`${getLabel(15148, '提醒')}(0)`}</td>
                                </tr>
                            </table>
                        </div>
                        <table width="100%">
                            {tr}{tr2}{tr}{tr2}{tr}{tr2}{tr}{tr2}{tr}
                        </table>
                    </div>
                    <div className="footer" id={`footer_${eid}`} style={{ textAlign: 'right' }}>
                        {moreLocal == 'footer' ? <a href="javascript:;"><img src={addContentPath(iconMore)} alt="" /></a> : ''}
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal4public/wea-element-preview/content/Content_blogStatus.js